import { 
    useState, 
    useEffect, 
    useMemo,
    useRef 
}                       from 'react';

export const Dropdown = props => {
    const p                 = props;
    const container         = useRef(null);
    const [ isToggled, setIsToggled ] = useState(false);
    const [ s, setState ]   = useState({
        options         : p.options,
        selected        : null
    })

    const toggleMenu = e => {
        if (container.current && !container.current.contains(e.target)) {
            setIsToggled(false);
        }
    }

    useEffect(() => {
        const handleClick = (e) => {
            toggleMenu(e);
        };

        if (p.value) {
            const item = p.options.find( option => option?.value === p?.value );
            setState(prevState => ({
                ...prevState,
                selected: item || null,
                options: p.options
            }));   
        }

        window.document.addEventListener('click', handleClick)

        return () => { window.document.removeEventListener('click', handleClick ) }
    /* eslint-disable-next-line */
    }, [])


    const toggle = () => {
        setIsToggled(prev => !prev);
    }

    const onSelect = (option, e) => {
        e.preventDefault();
        e.stopPropagation();
        setState(prevState => ({
            ...prevState,
            selected: option
        }));   

        setIsToggled(false);

        if (typeof p.onChange === 'function')
            p.onChange(option);
    }

    const getOptions = useMemo(() => {
        return p.options.map((option, index) => {
            return <li 
                        key         = { 'opt-' + index }
                        className   = { `anm${s?.selected?.value === option.value ? ' selected' : ''}` }
                        onClick     = { e => onSelect(option, e) }
                    >
                        { option.text }
                    </li>
        })

    /* eslint-disable-next-line */
    }, [ p.options ])

    return (
        <div ref={ container } onClick={ () => toggle() } className={ `simpra-dropdown${isToggled ? ' toggled' : ''}`  }>
            <div className={ `simpra-dropdown-wrapper${isToggled ? ' toggled' : ''}`  }>
                <div className="simpra-dropdown-value">
                    { s.selected?.text || 'Seçin...' }
                </div>
                <div className="simpra-dropdown-content anm">
                    <ul className="simpra-dropdown-list">
                        { getOptions }
                    </ul>
                </div>
            </div>
        </div>       
    )
}

export default Dropdown;